/* eslint-disable */
import { useLazyQuery } from "@apollo/client";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MenuIcon from "@mui/icons-material/Menu";
import StarIcon from "@mui/icons-material/Star";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Link,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import KeywordHeader from "../components/Keyword-Ranking-Table/KeywordHeader";
import MainLoader from "../components/MainLoader/MainLoader";
import { usePopup } from "../context/commonPop";
import { GET_AVG_POSITION_CHART_DATA } from "../gql/queries/googleRanking";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 64px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "80px",
  "& .keywordResultTable": {
    width: "100%",
    "& .tableFooter": {
      padding: "20px 15px 20px 15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
      gap: "20px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
      },
      "& .filteredContent": {
        "@media screen and (max-width:600px)": {
          flexWrap: "wrap",
          justifyContent: "space-between",
        },
      },
      "& .paginationBox": {
        backgroundColor: "#2A35470D",
        padding: "3px 4px",
        minWidth: "200px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px",
        "& button": {
          padding: "0",
          backgroundColor: "transparent",
          "&:focus": {
            outline: "none",
          },
          "&:hover": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          },
        },
        "& .actionBtnBox": {
          color: "#757575",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "&:hover": {
            color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            "& svg": {
              fill: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
            },
          },
          "& svg": {
            fill: "#757575",
          },
          "& span": {
            fill: "#757575",
          },
        },
        "& .pageValue": {
          borderLeft: "1px solid #757575",
          borderRight: "1px solid #757575",
          padding: "0 5px",
          "& p": {
            fontSize: "12px",
            fontWeight: 700,
            lineHeight: "15.12px",
            textAlign: "left",
            color: theme.palette.text.primary,
          },
        },
      },
      "& .enteredTop": {
        width: "6px",
        height: "6px",
        backgroundColor: "#0276E3",
        borderRadius: "50%",
      },
      "& .inTop": {
        width: "6px",
        height: "6px",
        backgroundColor: "#3DAE88",
        borderRadius: "50%",
      },
      "& .leftTop": {
        width: "6px",
        height: "6px",
        backgroundColor: "#FF6445",
        borderRadius: "50%",
      },
      "& .EnterTopHundred": {
        width: "6px",
        height: "6px",
        backgroundColor: "#7687A3",
        borderRadius: "50%",
      },
      "& .footerInnerContent": {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "& p": {
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "15.12px",
          textAlign: "left",
          color: "#808080",
          "& span": {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "15.12px",
            textAlign: "left",
            color: "#808080",
          },
        },
      },
    },
    "& .innerTableGrid": {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "7px 7px 7px 7px",
      "& table thead": {
        backgroundColor: theme.palette.text.primary,
        "& tr th": {
          color: theme.palette.mode === "dark" ? "#2A3547" : "#fff",
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "15.12px",
          textAlign: "center",
          "&:first-of-type": {
            textAlign: "left",
            "@media screen and (max-width:600px)": {
              minWidth: "190px",
            },
          },
          "&:nth-of-type(2)": {
            textAlign: "left",
            "@media screen and (max-width:600px)": {
              minWidth: "190px",
            },
          },
          "&:nth-of-type(3)": {
            textAlign: "left",
            "@media screen and (max-width:600px)": {
              minWidth: "190px",
            },
          },
        },
      },
      "& table ": {
        border: "1px solid #E3E3E3",
      },
      "& table tbody": {
        height: "190px",
        overflow: "auto",
        "& tr": {
          "&:last-of-type": {
            borderBottom: "1px solid ",
          },
        },
        "& tr td": {
          color: theme.palette.text.primary,
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "15.12px",
          textAlign: "left",
          "& .serpFeature": {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            "& .starIcon": {
              color: theme.palette.primary.main,
            },
            "& .videoIcon": {
              color: "#7F7F7F",
            },
          },
          "& .dateBoxes": {
            backgroundColor: "#bbbbbb14",
            textAlign: "center",
            padding: "6px",
            borderRadius: "4px",
          },
          "& .contentScore": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: "20px",
            color: "#fff",
            "& .inpuField": {
              width: "46px",
              "& fieldset": {
                display: "none",
              },
              "& input": {
                padding: "3px 9px",
                textAlign: "center",
                color: "#fff",
              },
            },
          },
          "& .contentScoreWarning": {
            backgroundColor: "#FFFF00",
            borderRadius: "20px",
            color: "#ffffff",
            "& .inpuField": {
              width: "46px",
              "& fieldset": {
                display: "none",
              },
              "& input": {
                padding: "3px 9px",
                textAlign: "center",
                color: "#000",
              },
            },
          },
          "& .contentScoreDanger": {
            backgroundColor: "#ff0000",
            borderRadius: "20px",
            color: "#fff",
            "& .inpuField": {
              width: "46px",
              "& fieldset": {
                display: "none",
              },
              "& input": {
                padding: "3px 9px",
                textAlign: "center",
                color: "#fff",
              },
            },
          },
          "& .contentScoreDown": {
            "& svg": {
              fill: "red",
            },
            "& span": {
              color: "red",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "15.12px",
              textAlign: "left",
            },
          },
          "& .contentScoreInner": {
            color: theme.palette.primary.main,
            "& span": {
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "15.12px",
              textAlign: "left",
            },
          },
        },
      },
    },
  },
}));

function LegendAndPagination({ currentPage, totalPages, handleNext, handlePrevious }) {
  return (
    <Box className="tableFooter">
      <Stack direction="row" spacing={2} className="filteredContent">
        <Box className="footerInnerContent">
          <Typography component="span" className="enteredTop"></Typography>
          <Typography component="p">
            Entered Top <Typography component="span">10</Typography>{" "}
          </Typography>
        </Box>
        <Box className="footerInnerContent">
          <Typography component="span" className="inTop"></Typography>
          <Typography component="p">
            In Top <Typography component="span">10</Typography>
          </Typography>
        </Box>
        <Box className="footerInnerContent">
          <Typography component="span" className="leftTop"></Typography>
          <Typography component="p">
            Left Top <Typography component="span">10</Typography>
          </Typography>
        </Box>
        <Box className="footerInnerContent">
          <Typography component="span" className="EnterTopHundred"></Typography>
          <Typography component="p">
            Entered Top <Typography component="span">100</Typography>
          </Typography>
        </Box>
      </Stack>
      <Box className="paginationBox">
        <Button onClick={handlePrevious} disabled={currentPage === 1}>
          <ArrowLeftIcon />
          <Typography component="span">Previous</Typography>
        </Button>
        <Box className="pageValue">
          <Typography component="p">
            Page {currentPage} of {totalPages}
          </Typography>
        </Box>
        <Button onClick={handleNext} disabled={currentPage === totalPages}>
          <Typography component="span">Next</Typography>
          <ArrowRightIcon />
        </Button>
      </Box>
    </Box>
  );
}
function KeywordRankingTablePage() {
  const [rankingData, setRankingData] = useState(null);
  const [dropDownValue, setDropDownValue] = useState(50);
  const [search, setSearch] = useState(null);
  const { handleOpen } = usePopup();
  const [scoreValue, setScoreValue] = useState(98);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredRows, setFilteredRows] = useState();
  const [startDate, setStartDate] = useState(dayjs().subtract(6, "day"));
  const [endDate, setEndDate] = useState(dayjs());
  const rowsPerPage = 10;
  const [getData] = useLazyQuery(GET_AVG_POSITION_CHART_DATA, { fetchPolicy: "cache-and-network" });
  const formatLocalDate = date => (date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ") : null);

  const rows = search && filteredRows?.length > 0 ? filteredRows : rankingData?.rows || [];

  const paginatedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const totalPages = Math.ceil(rows.length / rowsPerPage);

  const handleNext = () => {
    setCurrentPage(prev => (prev < totalPages ? prev + 1 : prev));
  };

  const handlePrevious = () => {
    setCurrentPage(prev => (prev > 1 ? prev - 1 : prev));
  };
  const handleFetch = () => {
    getData({
      variables: {
        input: {
          currentPage: 1,
          lastNDays: 6,
          limitSet: dropDownValue || 50,
          searchKeyword: search,
          startDate: formatLocalDate(startDate),
          endDate: formatLocalDate(endDate),
        },
      },
      onCompleted: ({ GetKeywordWithRanks }) => {
        setRankingData(GetKeywordWithRanks);
      },
      onError: error => {
        console.log(error);
        handleOpen(true, error.message || "Something went wrong");
      },
    });
  };

  useEffect(() => {
    handleFetch();
  }, [dropDownValue, search]);

  const debouncedHandleChange = useCallback(
    debounce(value => {
      setSearch(value);
    }, 300),
    [],
  );
  const handleChange = e => {
    if (e.target.name == "search") return debouncedHandleChange(e.target.value);
    return setDropDownValue(e.target.value);
  };

  const handlescoreValue = e => {
    setScoreValue(e.value.target);
  };

  const handleDateRangeChange = newValue => {
    const [newStart, newEnd] = newValue;
    setStartDate(newStart ? new Date(newStart) : null);
    setEndDate(newEnd ? new Date(newEnd) : null);
  };

  return !rankingData || Object.keys(rankingData).length === 0 ? (
    <MainLoader />
  ) : (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <KeywordHeader handleChange={handleChange} />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <Box className="keywordResultTable">
                <TableContainer className="innerTableGrid">
                  <Table>
                    <TableHead>
                      <TableRow>
                        {rankingData?.columns.map(column => (
                          <TableCell key={column}>{column}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedRows?.map(row => (
                        <TableRow key={row.id}>
                          <TableCell>{row.keywords}</TableCell>
                          <TableCell>
                            <Box className="serpFeature">
                              <Divider orientation="vertical" variant="middle" flexItem sx={{ width: "1px", height: "16px", backgroundColor: "#E3E3E3" }} />
                              <Tooltip title="This is a star feature" arrow>
                                <Link href={row?.cse_image?.[0].src || ""} target={"_blank"}>
                                  <StarIcon className={row?.cse_image?.[0].src ? "starIcon" : "videoIcon"} />
                                </Link>
                              </Tooltip>
                              <Tooltip title="This is a star feature" arrow>
                                {/* <Link href={row?.cse_video?.[0].src || ""} target={"_blank"}> */}
                                {/* <YouTubeIcon className={row?.cse_video?.[0].src ? "starIcon" : "videoIcon"} /> */}
                                {/* </Link> */}
                              </Tooltip>
                              <Tooltip title="This is a star feature" arrow>
                                <Link href={row?.cse_thumbnail?.[0].src || ""} target={"_blank"}>
                                  <MenuIcon className={row?.cse_thumbnail?.[0].src ? "starIcon" : "videoIcon"} />
                                </Link>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Divider orientation="vertical" variant="middle" flexItem sx={{ width: "1px", height: "16px", backgroundColor: "#E3E3E3" }} />
                              <Box className={scoreValue < 50 ? "contentScoreDanger" : scoreValue < 70 ? "contentScoreWarning" : "contentScore"}>
                                <TextField
                                  variant="outlined"
                                  value={scoreValue}
                                  className="inpuField"
                                  onChange={handlescoreValue}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Box>
                              <Box className={scoreValue < 60 ? "contentScoreDown" : "contentScoreInner"}>
                                <ArrowDropUpIcon />
                                <Typography component="span">07</Typography>
                              </Box>
                            </Box>
                          </TableCell>

                          {rankingData?.isoDates.map(date => (
                            <TableCell key={date}>
                              <Box className="dateBoxes">{row[date]}</Box>
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <LegendAndPagination currentPage={currentPage} totalPages={totalPages} handleNext={handleNext} handlePrevious={handlePrevious} />
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default KeywordRankingTablePage;
